import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center space-x-3" }
const _hoisted_4 = { class: "flex items-center space-x-2 mt-0.5" }
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "p-6 space-y-6" }
const _hoisted_8 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_9 = { class: "flex items-center space-x-2" }
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex items-center space-x-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "flex items-center space-x-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-3 gap-4"
}
const _hoisted_17 = { class: "flex items-start justify-between" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = { class: "flex items-start justify-between" }
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = { class: "flex items-start justify-between" }
const _hoisted_22 = { class: "flex-1" }
const _hoisted_23 = { class: "flex items-start space-x-4" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = { class: "mt-1.5 text-sm text-red-700 dark:text-red-300" }
const _hoisted_26 = { class: "flex flex-col items-center justify-center space-y-4" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = {
  key: 3,
  class: "relative"
}
const _hoisted_29 = {
  key: 0,
  class: "absolute inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-20 rounded-xl backdrop-blur-sm"
}
const _hoisted_30 = { class: "grid grid-cols-12 gap-2 px-4 py-2.5" }
const _hoisted_31 = { class: "flex items-center space-x-1" }
const _hoisted_32 = {
  key: 0,
  class: "w-4 h-4 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_33 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_34 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_35 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_36 = {
  key: 0,
  class: "w-4 h-4 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_37 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_38 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_39 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_40 = {
  key: 0,
  class: "w-4 h-4 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_41 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_42 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_43 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_44 = {
  key: 0,
  class: "w-4 h-4 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_45 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_46 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_47 = { class: "flex items-center justify-center space-x-1" }
const _hoisted_48 = {
  key: 0,
  class: "w-4 h-4 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_49 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_50 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_51 = { class: "flex items-center space-x-1" }
const _hoisted_52 = {
  key: 0,
  class: "w-4 h-4 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_53 = {
  key: 0,
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_54 = {
  key: 1,
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}
const _hoisted_55 = { class: "col-span-1 text-center" }
const _hoisted_56 = { class: "col-span-3 flex items-center space-x-2" }
const _hoisted_57 = { class: "col-span-1 text-center" }
const _hoisted_58 = { class: "col-span-1 text-center" }
const _hoisted_59 = { class: "col-span-1 text-center" }
const _hoisted_60 = { class: "col-span-1 text-center" }
const _hoisted_61 = { class: "col-span-4" }
const _hoisted_62 = { class: "space-y-1" }
const _hoisted_63 = { class: "flex items-center justify-between" }
const _hoisted_64 = { class: "relative w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 overflow-hidden" }
const _hoisted_65 = { class: "col-span-1 text-center" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "flex flex-col items-center justify-center space-y-4" }
const _hoisted_68 = { class: "max-w-md" }
const _hoisted_69 = { class: "flex items-center justify-center space-x-2" }

import { ref, reactive, computed, onMounted, inject, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import { leaderboardService } from '../../services/quality-gates'
import type { LeaderboardDetailsResponse, TimeRange } from '../../types/quality-gates'
import { logger } from '../../utils/logger'


export default /*@__PURE__*/_defineComponent({
  __name: 'details',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const theme = inject('theme', useTheme())

// State
const detailsData = ref<LeaderboardDetailsResponse | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const teams = ref<string[]>([])
const subTeams = ref<string[]>([])
const qualityGates = ref<string[]>([])

// Filters from query params
const filters = reactive({
  team: '',
  subTeam: '',
  qualityGate: '',
  timeRange: '7d' as TimeRange
})

// Sort state
const sortState = reactive({
  column: 'passRate' as 'name' | 'pass' | 'fail' | 'warning' | 'total' | 'passRate',
  order: 'asc' as 'asc' | 'desc'
})

// Computed
const teamDisplayName = computed(() => {
  return leaderboardService.formatTeamName(filters.team)
})

const subTeamDisplayName = computed(() => {
  return filters.subTeam ? leaderboardService.formatSubTeamName(filters.subTeam) : ''
})

const qualityGateDisplayName = computed(() => {
  return filters.qualityGate ? leaderboardService.formatGateName(filters.qualityGate) : ''
})

const updateURL = () => {
  const query: Record<string, string> = {
    team: filters.team,
    timeRange: filters.timeRange
  }

  if (filters.subTeam) {
    query.subTeam = filters.subTeam
  }

  if (filters.qualityGate) {
    query.qualityGate = filters.qualityGate
  }

  router.replace({ query })
}

const sortedGateStats = computed(() => {
  if (!detailsData.value) return []

  return [...detailsData.value.gateStats].sort((a, b) => {
    let comparison = 0

    switch (sortState.column) {
      case 'name':
        comparison = a.gateName.localeCompare(b.gateName)
        break
      case 'pass':
        comparison = a.pass - b.pass
        break
      case 'fail':
        comparison = a.fail - b.fail
        break
      case 'warning':
        comparison = a.warning - b.warning
        break
      case 'total':
        comparison = a.total - b.total
        break
      case 'passRate':
        comparison = a.passRate - b.passRate
        break
    }

    return sortState.order === 'asc' ? comparison : -comparison
  })
})

const totalFailingGates = computed(() => {
  if (!detailsData.value) return 0
  return detailsData.value.gateStats.filter((stat) => stat.fail > 0).length
})

// Methods
const fetchDetails = async () => {
  if (!filters.team) {
    error.value = 'Team parameter is required'
    return
  }

  try {
    loading.value = true
    error.value = null

    updateURL()

    logger.log('Fetching leaderboard details:', filters)

    const data = await leaderboardService.fetchLeaderboardDetails({
      team: filters.team,
      subTeam: filters.subTeam || undefined,
      qualityGate: filters.qualityGate || undefined,
      timeRange: filters.timeRange
    })

    detailsData.value = data

    logger.log('Details loaded:', {
      team: data.team,
      totalPRs: data.totalPRs,
      gatesCount: data.gateStats.length
    })
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to load details'
    logger.error('Error fetching leaderboard details:', err)
  } finally {
    loading.value = false
  }
}

const fetchFilterOptions = async () => {
  try {
    const [teamsData, gatesData] = await Promise.all([
      leaderboardService.fetchTeams(),
      leaderboardService.fetchQualityGates()
    ])
    teams.value = teamsData.teams
    subTeams.value = teamsData.subTeams
    qualityGates.value = gatesData.gates
  } catch (err) {
    logger.error('Failed to fetch filter options:', err)
  }
}

const onTeamChange = () => {
  // Reset sub-team when team changes so stale combinations are avoided.
  filters.subTeam = ''
  fetchDetails()
}

const goBack = () => {
  const query: Record<string, string> = {
    timeRange: filters.timeRange,
    groupBy: filters.subTeam ? 'subTeam' : 'team'
  }

  if (filters.team) {
    query.team = filters.team
  }

  if (filters.qualityGate) {
    query.qualityGate = filters.qualityGate
  }

  router.push({
    path: '/quality-gates/compliance',
    query
  })
}

const navigateToPRList = () => {
  const query: Record<string, string> = {}
  if (filters.team) query.team = filters.team
  if (filters.subTeam) query.subTeam = filters.subTeam
  if (filters.qualityGate) query.qualityGate = filters.qualityGate
  if (filters.timeRange) query.timeRange = filters.timeRange

  router.push({
    path: '/quality-gates/compliance/prs',
    query
  })
}

const navigateToPRListForGate = (gateName: string) => {
  const query: Record<string, string> = {}
  if (filters.team) query.team = filters.team
  if (filters.subTeam) query.subTeam = filters.subTeam
  query.qualityGate = gateName
  if (filters.timeRange) query.timeRange = filters.timeRange

  router.push({
    path: '/quality-gates/compliance/prs',
    query
  })
}

const formatGeneratedAt = (isoString: string): string => {
  try {
    const date = new Date(isoString)
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    })
  } catch {
    return isoString
  }
}

const sortBy = (column: typeof sortState.column) => {
  if (sortState.column === column) {
    // Toggle order if clicking the same column
    sortState.order = sortState.order === 'asc' ? 'desc' : 'asc'
  } else {
    // Set new column and default to descending for numbers, ascending for names
    sortState.column = column
    sortState.order = column === 'name' ? 'asc' : 'desc'
  }
}

// Initialize from route query params
const initFromRoute = () => {
  filters.team = (route.query.team as string) || ''
  filters.subTeam = (route.query.subTeam as string) || ''
  filters.qualityGate = (route.query.qualityGate as string) || ''
  filters.timeRange = ((route.query.timeRange as string) || '7d') as TimeRange
}

// Watch for route changes
watch(
  () => route.query,
  () => {
    initFromRoute()
    if (filters.team) {
      fetchDetails()
    }
  },
  { immediate: false }
)

// Lifecycle
onMounted(() => {
  initFromRoute()
  fetchFilterOptions()
  if (filters.team) {
    fetchDetails()
  } else {
    error.value = 'Team parameter is required. Please navigate from the compliance view.'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-3'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100',
              'p-2 rounded-lg transition-all'
            ]),
            title: "Back to Compliance",
            onClick: goBack
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M10 19l-7-7m0 0l7-7m-7 7h18"
              })
            ], -1)
          ]), 2),
          _createElementVNode("div", {
            class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50',
              'flex items-center justify-center w-9 h-9 rounded-lg'
            ])
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([_unref(theme).isDark.value ? 'text-purple-400' : 'text-purple-600', 'w-5 h-5']),
              fill: "currentColor",
              viewBox: "0 0 20 20"
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
                "clip-rule": "evenodd"
              }, null, -1)
            ]), 2))
          ], 2),
          _createElementVNode("div", null, [
            _createElementVNode("h1", {
              class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900', 'text-xl font-bold'])
            }, " Compliance Breakdown ", 2),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium'
                ])
              }, _toDisplayString(teamDisplayName.value), 3),
              (subTeamDisplayName.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-500' : 'text-gray-400', 'text-xs'])
                  }, " / ", 2))
                : _createCommentVNode("", true),
              (subTeamDisplayName.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-blue-400' : 'text-blue-600',
                  'text-xs font-semibold'
                ])
                  }, _toDisplayString(subTeamDisplayName.value), 3))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-blue-500 hover:bg-blue-600 text-white',
              'px-3 py-1.5 rounded-lg text-xs font-medium transition-all flex items-center shadow-sm hover:shadow'
            ]),
            onClick: navigateToPRList
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              class: "w-3.5 h-3.5 mr-1.5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              })
            ], -1),
            _createTextVNode(" View PRs ")
          ]), 2),
          _createElementVNode("button", {
            disabled: loading.value,
            class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-gray-700 hover:bg-gray-600 text-gray-200'
                : 'bg-white hover:bg-gray-50 text-gray-700',
              'px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg text-xs font-medium transition-all flex items-center shadow-sm hover:shadow',
              loading.value ? 'opacity-50 cursor-not-allowed' : ''
            ]),
            onClick: fetchDetails
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([loading.value ? 'animate-spin' : '', 'w-3.5 h-3.5 mr-1.5']),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              }, null, -1)
            ]), 2)),
            _createTextVNode(" " + _toDisplayString(loading.value ? 'Loading...' : 'Refresh'), 1)
          ], 10, _hoisted_6)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-3 shadow-sm'
        ])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium whitespace-nowrap'
              ])
            }, " Time Range: ", 2),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.timeRange) = $event)),
              class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                  : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer'
              ]),
              onChange: fetchDetails
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("option", { value: "7d" }, "Last 7 Days", -1),
              _createElementVNode("option", { value: "14d" }, "Last 14 Days", -1),
              _createElementVNode("option", { value: "30d" }, "Last 30 Days", -1)
            ]), 34), [
              [_vModelSelect, filters.timeRange]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([_unref(theme).isDark.value ? 'bg-gray-700' : 'bg-gray-300', 'w-px h-6'])
          }, null, 2),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium'
              ])
            }, " Team: ", 2),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.team) = $event)),
              class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                  : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer'
              ]),
              onChange: onTeamChange
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teams.value, (team) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: team,
                  value: team
                }, _toDisplayString(_unref(leaderboardService).formatTeamName(team)), 9, _hoisted_11))
              }), 128))
            ], 34), [
              [_vModelSelect, filters.team]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", {
              class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium'
              ])
            }, " Sub-Team: ", 2),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.subTeam) = $event)),
              class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                  : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer'
              ]),
              onChange: fetchDetails
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "All Sub-Teams", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTeams.value, (subTeam) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: subTeam,
                  value: subTeam
                }, _toDisplayString(_unref(leaderboardService).formatSubTeamName(subTeam)), 9, _hoisted_13))
              }), 128))
            ], 34), [
              [_vModelSelect, filters.subTeam]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                'text-xs font-medium'
              ])
            }, " Quality Gate: ", 2),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.qualityGate) = $event)),
              class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-650'
                  : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50',
                'px-3 py-1.5 border rounded-md text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all cursor-pointer'
              ]),
              onChange: fetchDetails
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "All Gates", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualityGates.value, (gate) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: gate,
                  value: gate
                }, _toDisplayString(_unref(leaderboardService).formatGateName(gate)), 9, _hoisted_15))
              }), 128))
            ], 34), [
              [_vModelSelect, filters.qualityGate]
            ])
          ])
        ])
      ], 2),
      (detailsData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, " Total PRs ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-purple-400' : 'text-purple-600',
                  'text-3xl font-bold'
                ])
                  }, _toDisplayString(detailsData.value.totalPRs), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'bg-purple-900 bg-opacity-30' : 'bg-purple-50',
                'flex items-center justify-center w-10 h-10 rounded-lg'
              ])
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-purple-400' : 'text-purple-600', 'w-5 h-5']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, _cache[17] || (_cache[17] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ]), 2))
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, " Quality Gates ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-blue-400' : 'text-blue-600',
                  'text-3xl font-bold'
                ])
                  }, _toDisplayString(detailsData.value.gateStats.length), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'bg-blue-900 bg-opacity-30' : 'bg-blue-50',
                'flex items-center justify-center w-10 h-10 rounded-lg'
              ])
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-blue-400' : 'text-blue-600', 'w-5 h-5']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, _cache[18] || (_cache[18] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ]), 2))
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-800 border border-gray-700'
              : 'bg-white border border-gray-200',
            'rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow'
          ])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                  'text-xs font-medium mb-2'
                ])
                  }, " Gates with Failures ", 2),
                  _createElementVNode("p", {
                    class: _normalizeClass([
                  _unref(theme).isDark.value ? 'text-red-400' : 'text-red-600',
                  'text-3xl font-bold'
                ])
                  }, _toDisplayString(totalFailingGates.value), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'bg-red-900 bg-opacity-30' : 'bg-red-50',
                'flex items-center justify-center w-10 h-10 rounded-lg'
              ])
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([_unref(theme).isDark.value ? 'text-red-400' : 'text-red-600', 'w-5 h-5']),
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, _cache[19] || (_cache[19] = [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                      "clip-rule": "evenodd"
                    }, null, -1)
                  ]), 2))
                ], 2)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-red-900 border-red-700' : 'bg-red-50 border-red-200',
          'border rounded-xl p-6 shadow-sm'
        ])
          }, [
            _createElementVNode("div", _hoisted_23, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("div", { class: "flex items-center justify-center w-10 h-10 rounded-full bg-red-200 dark:bg-red-800" }, [
                  _createElementVNode("svg", {
                    class: "h-5 w-5 text-red-600 dark:text-red-300",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_24, [
                _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-base font-semibold text-red-800 dark:text-red-200" }, " Error Loading Details ", -1)),
                _createElementVNode("p", _hoisted_25, _toDisplayString(error.value), 1),
                _createElementVNode("button", {
                  class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'bg-red-800 hover:bg-red-700 text-red-100'
                  : 'bg-red-600 hover:bg-red-700 text-white',
                'mt-3 px-4 py-2 rounded-lg text-sm font-medium transition-all shadow-sm hover:shadow'
              ]),
                  onClick: fetchDetails
                }, " Try Again ", 2)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (loading.value && !detailsData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-xl p-12 shadow-sm'
        ])
          }, [
            _createElementVNode("div", _hoisted_26, [
              _cache[22] || (_cache[22] = _createElementVNode("svg", {
                class: "animate-spin h-12 w-12 text-blue-500",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", {
                  class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
                'text-base font-medium'
              ])
                }, " Loading gate breakdown... ", 2),
                _createElementVNode("p", {
                  class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-500' : 'text-gray-500', 'text-xs mt-1'])
                }, " Analyzing quality gate results ", 2)
              ])
            ])
          ], 2))
        : (detailsData.value && sortedGateStats.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[23] || (_cache[23] = [
                    _createStaticVNode("<div class=\"flex flex-col items-center\"><svg class=\"animate-spin h-10 w-10 text-blue-500 mb-3\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg><p class=\"text-white text-sm font-medium\">Updating data...</p></div>", 1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
            'border rounded-xl overflow-hidden shadow-sm'
          ])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-900 border-gray-700' : 'bg-gray-50 border-gray-200',
              'border-b'
            ])
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      class: "col-span-3 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded px-2 py-1 -mx-2 -my-1 select-none",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('name')))
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                      'text-xs font-semibold uppercase tracking-wider'
                    ])
                        }, " Quality Gate ", 2),
                        (sortState.column === 'name')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_32, [
                              (sortState.order === 'asc')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_33))
                                : (_openBlock(), _createElementBlock("path", _hoisted_34))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-span-1 text-center cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded px-2 py-1 -mx-2 -my-1 select-none",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('pass')))
                    }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                      'text-xs font-semibold uppercase tracking-wider'
                    ])
                        }, " Pass ", 2),
                        (sortState.column === 'pass')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_36, [
                              (sortState.order === 'asc')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_37))
                                : (_openBlock(), _createElementBlock("path", _hoisted_38))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-span-1 text-center cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded px-2 py-1 -mx-2 -my-1 select-none",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (sortBy('fail')))
                    }, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                      'text-xs font-semibold uppercase tracking-wider'
                    ])
                        }, " Fail ", 2),
                        (sortState.column === 'fail')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_40, [
                              (sortState.order === 'asc')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_41))
                                : (_openBlock(), _createElementBlock("path", _hoisted_42))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-span-1 text-center cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded px-2 py-1 -mx-2 -my-1 select-none",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (sortBy('warning')))
                    }, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                      'text-xs font-semibold uppercase tracking-wider'
                    ])
                        }, " Warning ", 2),
                        (sortState.column === 'warning')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_44, [
                              (sortState.order === 'asc')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_45))
                                : (_openBlock(), _createElementBlock("path", _hoisted_46))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-span-1 text-center cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded px-2 py-1 -mx-2 -my-1 select-none",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (sortBy('total')))
                    }, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                      'text-xs font-semibold uppercase tracking-wider'
                    ])
                        }, " Total ", 2),
                        (sortState.column === 'total')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_48, [
                              (sortState.order === 'asc')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_49))
                                : (_openBlock(), _createElementBlock("path", _hoisted_50))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-span-4 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded px-2 py-1 -mx-2 -my-1 select-none",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (sortBy('passRate')))
                    }, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                      _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                      'text-xs font-semibold uppercase tracking-wider'
                    ])
                        }, " Performance ", 2),
                        (sortState.column === 'passRate')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_52, [
                              (sortState.order === 'asc')
                                ? (_openBlock(), _createElementBlock("path", _hoisted_53))
                                : (_openBlock(), _createElementBlock("path", _hoisted_54))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                    _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                    'text-xs font-semibold uppercase tracking-wider'
                  ])
                      }, " Actions ", 2)
                    ])
                  ])
                ], 2),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedGateStats.value, (stat, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: stat.gateName,
                      class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'hover:bg-gray-700 border-gray-700'
                  : 'hover:bg-gray-50 border-gray-200',
                'grid grid-cols-12 gap-2 px-4 py-3 border-b last:border-b-0 transition-colors items-center'
              ])
                    }, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                    stat.passRate >= 100
                      ? _unref(theme).isDark.value
                        ? 'bg-green-900 bg-opacity-30 text-green-400'
                        : 'bg-green-50 text-green-600'
                      : stat.passRate >= 80
                        ? _unref(theme).isDark.value
                          ? 'bg-yellow-900 bg-opacity-30 text-yellow-400'
                          : 'bg-yellow-50 text-yellow-600'
                        : _unref(theme).isDark.value
                          ? 'bg-red-900 bg-opacity-30 text-red-400'
                          : 'bg-red-50 text-red-600',
                    'flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold'
                  ])
                        }, _toDisplayString(index + 1), 3),
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    _unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'font-medium text-sm'
                  ])
                        }, _toDisplayString(_unref(leaderboardService).formatGateName(stat.gateName)), 3)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    _unref(theme).isDark.value
                      ? 'bg-green-900 bg-opacity-30 text-green-400'
                      : 'bg-green-50 text-green-700',
                    'inline-flex items-center justify-center w-8 h-8 rounded-lg text-xs font-bold'
                  ])
                        }, _toDisplayString(stat.pass), 3)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    _unref(theme).isDark.value
                      ? 'bg-red-900 bg-opacity-30 text-red-400'
                      : 'bg-red-50 text-red-700',
                    'inline-flex items-center justify-center w-8 h-8 rounded-lg text-xs font-bold'
                  ])
                        }, _toDisplayString(stat.fail), 3)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    _unref(theme).isDark.value
                      ? 'bg-yellow-900 bg-opacity-30 text-yellow-400'
                      : 'bg-yellow-50 text-yellow-700',
                    'inline-flex items-center justify-center w-8 h-8 rounded-lg text-xs font-bold'
                  ])
                        }, _toDisplayString(stat.warning), 3)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    _unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'font-semibold text-sm'
                  ])
                        }, _toDisplayString(stat.total), 3)
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        stat.passRate >= 100
                          ? _unref(theme).isDark.value
                            ? 'text-green-400'
                            : 'text-green-600'
                          : stat.passRate >= 80
                            ? _unref(theme).isDark.value
                              ? 'text-yellow-400'
                              : 'text-yellow-600'
                            : _unref(theme).isDark.value
                              ? 'text-red-400'
                              : 'text-red-600',
                        'text-sm font-bold'
                      ])
                            }, _toDisplayString(stat.passRate) + "% ", 3),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                        _unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600',
                        'text-xs font-medium'
                      ])
                            }, _toDisplayString(stat.passRate >= 100
                          ? 'Compliant'
                          : stat.passRate >= 80
                            ? 'At Risk'
                            : 'Non-Compliant'), 3)
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", {
                              class: _normalizeClass([[
                        stat.passRate >= 100
                          ? 'bg-green-500'
                          : stat.passRate >= 80
                            ? 'bg-yellow-500'
                            : 'bg-red-500'
                      ], "h-full transition-all duration-500"]),
                              style: _normalizeStyle({ width: `${stat.passRate}%` })
                            }, null, 6)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("button", {
                          class: _normalizeClass([
                    _unref(theme).isDark.value
                      ? 'bg-blue-600 hover:bg-blue-700 text-white'
                      : 'bg-blue-500 hover:bg-blue-600 text-white',
                    'px-3 py-1.5 rounded-lg text-xs font-semibold transition-all shadow-sm hover:shadow'
                  ]),
                          onClick: _withModifiers(($event: any) => (navigateToPRListForGate(stat.gateName)), ["stop"])
                        }, " View PRs ", 10, _hoisted_66)
                      ])
                    ], 2))
                  }), 128))
                ])
              ], 2)
            ]))
          : (detailsData.value && sortedGateStats.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-xl p-16 text-center shadow-sm'
        ])
              }, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-700" }, [
                    _createElementVNode("svg", {
                      class: "w-8 h-8 text-gray-400 dark:text-gray-500",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("p", {
                      class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
                'text-base font-semibold mb-1'
              ])
                    }, " No Quality Gate Data Available ", 2),
                    _createElementVNode("p", {
                      class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-500' : 'text-gray-500', 'text-sm'])
                    }, " No quality gate results found for this team in the selected time range. Try adjusting your filters or check back later. ", 2)
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-blue-500 hover:bg-blue-600 text-white',
              'px-4 py-2 rounded-lg text-sm font-medium transition-all shadow-sm hover:shadow mt-2'
            ]),
                    onClick: fetchDetails
                  }, " Refresh Data ", 2)
                ])
              ], 2))
            : _createCommentVNode("", true),
      (detailsData.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200',
          'border rounded-lg p-3 text-center'
        ])
          }, [
            _createElementVNode("div", _hoisted_69, [
              _cache[25] || (_cache[25] = _createElementVNode("svg", {
                class: "w-4 h-4 text-gray-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createElementVNode("span", {
                class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-400' : 'text-gray-600', 'text-xs font-medium'])
              }, " Data generated at " + _toDisplayString(formatGeneratedAt(detailsData.value.generatedAt)), 3)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})